<template>
  <div id="map">
    <div id="jlMap" style="height: 100%"></div>
    <el-select v-model="address" filterable remote value-key="uid" reserve-keyword :placeholder="$t('i18n.search')"
      :remote-method="remoteMethod" :loading="loading" @change="setLocation">
      <el-option v-for="item in options" :key="item.uid" :label="item.title" :value="item"></el-option>
    </el-select>
    <div class="footer">
      <el-button class="el-button--cancel" @click="addPoint(0)">
        {{ $t("i18n.cancel") }}
      </el-button>
      <el-button type="primary" @click="addPoint">
        {{ $t("i18n.confirm") }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { reactive, toRefs, onMounted,ref } from "vue";
// import { gcj02tobd09, wgs84togcj02 } from "../../public/js/map";
// import BMap from "BMap";
export default {
  name: "map",
  props: {
    region: {
      type: Object,
      default: () => { },
    },
  },
  emits: ["addPoint"],
  setup(props, { emit }) {
    emit("public_header", true);
    // const { proxy } = getCurrentInstance();
    const state = reactive({
      jlMap: null,
      address: "",
      loading: false,
      options: "",
      result: "",
    });
    const scriptLoaded = ref(false);
    let mapInstance = ref(null);
    const loadBMapScript = async () => {
      if (scriptLoaded.value) return Promise.resolve();

      return new Promise((resolve, reject) => {
        // 创建 script 标签
        const script = document.createElement('script');
        // 拼接 AK 和回调函数（回调函数名需唯一）
        script.src = `https://api.map.baidu.com/api?v=3.0&ak=lkpFC6vaOa89VWOpUDHRqOExmGZ1mmz4&callback=initBMap`;
        script.type = 'text/javascript';
        script.async = true;
        // 全局挂载回调函数，供百度地图脚本加载完成后调用
        window.initBMap = () => {
          scriptLoaded.value = true;
          resolve(window.BMap); // 3.0 版本默认是 BMap（GL版），若用基础版则为 window.BMap
        };
        // 脚本加载失败处理
        script.onerror = (err) => {
          reject(new Error('百度地图脚本加载失败'));
        };
        // 将脚本插入到 body 中
        document.body.appendChild(script);
      });
    };
    const initMap = async () => {
      state.address = props.region.addr;
      if (state.jlMap === null) {
        try {
          await loadBMapScript();
          var map = (state.jlMap = new window.BMap.Map("jlMap"));
          map.enableScrollWheelZoom(true);
          map.enableDragging();
          if (state.address) {
            remoteMethod(state.address, 1);
          } else {
            var geolocation = new window.BMap.LocalCity();
            geolocation.get(function (r) {
              if (r) {
                map.centerAndZoom(
                  new window.BMap.Point(r.center.lng, r.center.lat),
                  12
                );
              }
            });
          }
          map.addEventListener("click", function (e) {
            onClickEvent(e.point);
          });
        } catch (error) {

        }

      }
    };

    const remoteMethod = (query, flag) => {
      if (query !== "") {
        state.loading = true;
        setTimeout(() => {
          var map = state.jlMap;
          var local = new window.BMap.LocalSearch(map, {
            onSearchComplete: function (results) {
              console.log(results)
              state.loading = false;
              state.options = [];
              for (var i = 0; i < results.getCurrentNumPois(); i++) { state.options.push(results.getPoi(i)); }
              // state.options = results ? results.Br : [];
              if (flag === 1) {
                onClickEvent(state.options[0].point);
              }
            },
          });
          local.search(query);
        }, 200);
      } else {
        state.loading = false;
        state.options = [];
      }
    };

    const setLocation = () => {
      // 搜索后地图定位
      onClickEvent(state.address.point, state.address.title);
    };

    const onClickEvent = (p, address) => {
      var map = state.jlMap;
      var pt = new window.BMap.Marker(p);
      map.setViewport([p]);
      var geoc = new window.BMap.Geocoder();
      map.clearOverlays();
      map.addOverlay(pt);
      pt.setAnimation("BMAP_ANIMATION_BOUNCE");
      var pt2 = p;
      geoc.getLocation(pt2, function (rs) {
        state.result = address ? state.address : rs;
        state.result.addressComponents = rs.addressComponents;
        // state.address = rs.address;
      });
    };

    const addPoint = (flag) => {
      if (flag === 0) {
        state.result = "";
      }
      emit("addPoint", state.result);
    };

    onMounted(() => {
      initMap();
    });

    return {
      ...toRefs(state),
      remoteMethod,
      setLocation,
      addPoint,
    };
  },
};
</script>

<style lang="scss">
#map {
  height: 100%;
}

#positionMap {
  .el-select {
    position: absolute;
    top: 50px;
    left: 40px;
    min-width: $width * 2 + 40;
    width: 40%;
  }

  .footer {
    position: absolute;
    padding: 10px 20px 20px;
    top: 0;
    right: 0;
    z-index: 2;
  }
}
</style>
